import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import Select, { components } from 'react-select';
import { useTranslation } from 'react-i18next';
import { getJobsBySearchText } from '../../services/jobs';
import { debounce } from '../../utils/helper';
import { onQuerySuccess } from '../../utils/queryResponse';

/* sbr design-system styling for the global job search */
const colorStyles = {
    control: (base, state) => ({
        ...base,
        minHeight: 46,
        borderRadius: 12,
        borderColor: state.isFocused ? '#2563EB' : '#E9ECF3',
        boxShadow: state.isFocused ? '0 0 0 3px #EFF4FF' : '0 1px 2px rgba(16,24,40,.05)',
        fontSize: 14,
        backgroundColor: '#fff',
        transition: 'border-color .14s, box-shadow .14s',
        '&:hover': { borderColor: state.isFocused ? '#2563EB' : '#DCE7FF' },
    }),
    valueContainer: base => ({ ...base, padding: '2px 4px 2px 14px' }),
    placeholder: base => ({ ...base, fontSize: 14, color: '#9AA4B2', fontWeight: 500 }),
    input: base => ({ ...base, color: '#0B1424' }),
    menu: base => ({ ...base, borderRadius: 12, overflow: 'hidden', border: '1px solid #E9ECF3', boxShadow: '0 12px 30px -8px rgba(16,24,40,.18)', zIndex: 40 }),
    option: (base, state) => ({
        ...base,
        fontSize: 13.5,
        fontWeight: 600,
        padding: '10px 12px',
        color: state.isSelected ? '#fff' : '#1C2536',
        backgroundColor: state.isSelected ? '#2563EB' : state.isFocused ? '#EFF4FF' : '#fff',
        cursor: 'pointer',
    }),
    noOptionsMessage: base => ({ ...base, fontSize: 13, color: '#9AA4B2' }),
}

const JobsSelect = ({ value, isMulti, onChange, ...rest }) => {

    const { t } = useTranslation();
    const [searchText, setSearchText] = useState('')
    const [options, setOptions] = useState([])

    const { data, isLoading } = useQuery(['jobs-search', searchText], () => searchText && getJobsBySearchText(searchText))

    useEffect(() => {
        if (data) {
            onQuerySuccess(data, (result) => {
                if (result.length > 0) {
                    let _options = result.map((d) => ({
                        value: d.id,
                        label: `Job#${d.id}, ${d.firstName} ${d.lastName}, ${d.status} - Tag#${d.badgeNo}`,
                    }));
                    setOptions(_options);
                }
            });
        }
    }, [data, searchText]);

    const handleSearchText = debounce((text) => {
        setSearchText(text)
    })

    const NoOptionsMessage = props => {
        return (
            <components.NoOptionsMessage {...props}>
                <span>{t('common.nothingFound', 'Nothing found')}</span>
            </components.NoOptionsMessage>
        )
    }

    return (
        <Select
            value={value}
            options={options}
            isLoading={isLoading}
            onInputChange={handleSearchText}
            onChange={onChange}
            blurInputOnSelect
            components={{
                DropdownIndicator: () =>
                    <div className="d-inline rounded-0 right-rounded bg-transparent px-3">
                        <i className="fa-solid fa-magnifying-glass text-muted"></i>
                    </div>,
                IndicatorSeparator: () => null,
                NoOptionsMessage
            }}
            styles={colorStyles}
            placeholder={t('jobsSelect.searchPlaceholder', 'Search anything in Soroby…')}
            required
            {...rest} />
    )
}

export default JobsSelect